// Action names for delete multiple mails
export const ACTION_DELETE_SELECTED_ITEMS = 'deleteSelectedItems';
export const ACTION_DELETE_SELECTED_CONVERSATIONS = 'deleteSelectedConversations';
